import React, { useState, lazy, Suspense } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const MainCalculatorsList = React.lazy(() => import("./MainCalculators"));
const RelatedLinks = React.lazy(() => import("../RelatedLinks"));

const TITLE = "حاسبة مدة الوفاة بالميلادي - احسب كم مضى على الوفاة بدقة";
const DESCRIPTION =
  "استخدم حاسبة مدة الوفاة الدقيقة بالميلادي لمعرفة المدة الزمنية الكاملة التي انقضت منذ تاريخ الوفاة، مفصلة بالسنوات، الأشهر، الأيام، الساعات، الدقائق، والثواني. أداة مجانية وسهلة الاستخدام لحساب المدة منذ وفاة شخص عزيز.";
const KEYWORDS =
  "حاسبة مدة الوفاة, كم مضى على الوفاة, تاريخ الوفاة بالميلادي, حساب الفترة بعد الوفاة, المدة الزمنية للوفاة, وفاة شخص عزيز, تحديد مدة الوفاة, حاسبة مجانية للوفاة, حساب الأيام منذ الوفاة, حساب الأشهر منذ الوفاة, حساب السنوات منذ الوفاة";
const OG_URL = "https://do-calculate.com/calculator/ar/duration-since-death/";

const GREGORIAN_MONTHS = [
  "يناير / كانون الثاني", "فبراير / شباط", "مارس / آذار", "أبريل / نيسان",
  "مايو / أيار", "يونيو / حزيران", "يوليو / تموز", "أغسطس / آب",
  "سبتمبر / أيلول", "أكتوبر / تشرين الأول", "نوفمبر / تشرين الثاني", "ديسمبر / كانون الأول"
];

function DurationSinceDeathCalculatorGregorian() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);

  // استبدال حقل النص بكائن للتاريخ
  const [deathDateInput, setDeathDateInput] = useState({
    day: "1",
    month: "1",
    year: "2020"
  });

  const [durationGregorian, setDurationGregorian] = useState(null);

  const calculateDurationGregorian = async () => {
    setIsLoading(true);
    setError(null);
    setDurationGregorian(null);

    try {
      // بناء التاريخ من القوائم المنسدلة
      const deathDate = new Date(
        parseInt(deathDateInput.year),
        parseInt(deathDateInput.month) - 1,
        parseInt(deathDateInput.day)
      );

      const now = new Date();
      if (isNaN(deathDate.getTime()) || deathDate > now) {
        setError("تاريخ الوفاة غير صالح أو يقع في المستقبل.");
        setIsLoading(false);
        setStatusCode(400);
        return;
      }

      let diffMs = now - deathDate;
      const totalSeconds = Math.floor(diffMs / 1000);
      const remainingSeconds = totalSeconds % 60;
      const totalMinutes = Math.floor(totalSeconds / 60);
      const remainingMinutes = totalMinutes % 60;
      const totalHours = Math.floor(totalMinutes / 60);
      const remainingHours = totalHours % 24;

      let years = 0;
      let months = 0;
      let tempDate = new Date(deathDate.getTime());

      while (tempDate < now) {
        let nextMonth = new Date(tempDate.getFullYear(), tempDate.getMonth() + 1, tempDate.getDate());
        if (nextMonth <= now) {
          months++;
          tempDate = nextMonth;
        } else {
          break;
        }
      }

      years = Math.floor(months / 12);
      months = months % 12;
      let remainingDays = Math.floor((now - tempDate) / (1000 * 60 * 60 * 24));

      setDurationGregorian({
        years,
        months,
        days: remainingDays,
        hours: remainingHours,
        minutes: remainingMinutes,
        seconds: remainingSeconds,
      });
      setStatusCode(200);
    } catch (err) {
      console.error(err);
      setError("حدث خطأ أثناء حساب المدة.");
      setStatusCode(500);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8" >
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px", lineHeight: "50px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light p-3">
            <div className="row">
              <div>
                <p>
                  تساعدك هذه الحاسبة في تحديد <strong>المدة الزمنية التي انقضت منذ
                    تاريخ وفاة شخص ما</strong>، باستخدام <strong>التقويم الميلادي</strong>. سواء كنت ترغب
                  في تتبع المدة لذكرى سنوية، أو لأغراض إحصائية، أو لمجرد الفضول،
                  توفر لك هذه الأداة حسابًا دقيقًا. يمكنك إدخال تاريخ الوفاة
                  بالضبط، وستعرض لك الحاسبة المدة بالتفصيل: <strong>بالسنوات، الأشهر،
                    الأيام، الساعات، الدقائق، والثواني</strong> حتى اللحظة الحالية.
                </p>
                <p>
                  إن <strong>حساب مدة الوفاة</strong> لم يكن أسهل من الآن. هذه <strong>الحاسبة المجانية </strong>
                  مصممة لتكون سهلة الاستخدام وتوفر نتائج فورية. ما عليك سوى
                  إدخال تاريخ الوفاة المطلوب في الحقل المخصص له، ثم الضغط على
                  زر "احسب المدة". ستحصل على تفصيل كامل للمدة المنقضية، مما يمنحك
                  نظرة واضحة على الفترة الزمنية بدقة متناهية. ابدأ الآن واعرف
                  <strong>كم مضى على الوفاة</strong>!
                </p>
                <br />
              </div>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="calculatorStyle mb-3">
              <div className="p-3 mb-2 bg-success text-white text-center rounded">
                <h1 style={{ fontSize: "20px", margin: 0 }}>حاسبة المدة منذ الوفاة</h1>
              </div>
              <div className="col-12 col-md-4" >
                <label style={{ fontSize: "16px", fontWeight: "bold" }}>
                  أدخل تاريخ الوفاة في التقويم الميلادي
                </label>
              </div>
              <div className="row">

                <div className="col-12 col-md-8 text-center mb-3">
                  <div className="d-flex gap-2">
                    {/* قائمة الأيام */}
                    <select
                      className="form-control"
                      value={deathDateInput.day}
                      onChange={(e) => setDeathDateInput({ ...deathDateInput, day: e.target.value })}
                    >
                      {Array.from({ length: 31 }, (_, i) => i + 1).map(d => (
                        <option key={d} value={d}>{d}</option>
                      ))}
                    </select>

                    {/* قائمة الأشهر */}
                    <select
                      className="form-control"
                      value={deathDateInput.month}
                      onChange={(e) => setDeathDateInput({ ...deathDateInput, month: e.target.value })}
                    >
                      {GREGORIAN_MONTHS.map((m, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>
                      ))}
                    </select>

                    {/* قائمة السنوات */}
                    <select
                      className="form-control"
                      value={deathDateInput.year}
                      onChange={(e) => setDeathDateInput({ ...deathDateInput, year: e.target.value })}
                    >
                      {Array.from({ length: 120 }, (_, i) => new Date().getFullYear() - i).map(y => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col text-center">
                  <br />
                  <button
                    className="btn btn-success"
                    onClick={calculateDurationGregorian}
                    disabled={isLoading}
                  >
                    {isLoading ? "جاري الحساب..." : "احسب المدة"}
                  </button>
                  <br />
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col">
                  <br />
                  {statusCode === 400 && (
                    <div className="alert alert-warning">
                      <b>
                        <u> حدث خطأ :</u>
                      </b>{" "}
                      {error || "يُرجى إدخال تاريخ وفاة صحيح."}
                    </div>
                  )}
                  {durationGregorian && (
                    <div>
                      <br />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        <label>
                          <strong>المدة المنقضية:</strong>{" "}
                          {durationGregorian.years} عام و{" "}
                          {durationGregorian.months} شهر و{" "}
                          {durationGregorian.days} يوم و{" "}
                          {durationGregorian.hours} ساعة و{" "}
                          {durationGregorian.minutes} دقيقة و{" "}
                          {durationGregorian.seconds} ثانية
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <Suspense fallback={<div>جاري التحميل...</div>}>
              <RelatedLinks />
            </Suspense>
            <br />
            <hr />
          </div>
        </div>
        <div className="col-12 col-md-4">
          <SecondAds />
          <br />
          <Suspense fallback={<div>جاري التحميل...</div>}>
            <MainCalculatorsList />
          </Suspense>
          <br />
        </div>
      </div>
    </div>
  );
}

export default DurationSinceDeathCalculatorGregorian;